import React from 'react';
import {observer} from 'mobx-react';
import {Check} from '@sparkware/app-utils';

import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {MiniOrbitArenasHeaderComponent} from '../arenas-header/mini-orbit-arenas-header.component';
import {MainScreenComponent} from '../../../basic-components/main-screen/main-screen.component';
import {MiniOrbitSpinnerComponent} from "../spinner/mini-orbit-spinner.component";

export type MiniOrbitContentType = React.ReactNode | (() => React.ReactNode);

export interface MiniOrbitContentComponentProps {
    content: MiniOrbitContentType;
}

export const MiniOrbitContentComponent = observer(
    class MiniOrbitContentComponent extends OrbitComponent<MiniOrbitContentComponentProps> {

        private _isFunctionContent(content: MiniOrbitContentType): content is () => React.ReactNode {
            return Check.isFunction(content);
        }

        private _renderContent() {
            if(this._isFunctionContent(this.props.content)) {
                return this.props.content();
            } else {
                return this.props.content;
            }
        }

        private _renderArenasHeader() {
            if (!this.services.miniOrbit.currentMiniOrbitConfig?.useIosDesign) {
                return <MiniOrbitArenasHeaderComponent />;
            }
        }

        render() {
            return (
                <MainScreenComponent>
                    {this._renderArenasHeader()}
                    <MiniOrbitSpinnerComponent />
                    {this._renderContent()}
                </MainScreenComponent>
            )
        }
    }
);